var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgTooltip = function SvgTooltip(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 4.867c-.333 0-.6.266-.6.6 0 .333.267.6.6.6.333 0 .6-.267.6-.6 0-.334-.267-.6-.6-.6z",
    fill: "#F05"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 14c-3.333 0-6-2.667-6-6s2.667-6 6-6 6 2.667 6 6-2.667 6-6 6zM8 8v3.333",
    stroke: "#F05",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgTooltip;